<template>
  <v-container>
    <Header />
    <v-overlay :value="bookingLoader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      top
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="mx-auto" max-width="400" v-if="bookings.length == 0">
      <v-toolbar flat>
        <v-toolbar-title class="grey--text align-center"
          >Manage my bookings</v-toolbar-title
        >
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-alert type="error" v-model="message.showError">{{
          message.errorMessage
        }}</v-alert>
        <v-form ref="formManageBooking">
          <v-text-field
            v-model="booking.firstName"
            label="Your first name"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
          <v-text-field
            v-model="booking.lastName"
            label="Your last name"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
          <v-text-field
            v-model="booking.email"
            label="Email address"
            :rules="[rules.required, rules.email]"
            outlined
          ></v-text-field>
          <v-btn
            depressed
            large
            block
            class="managebookingsbutton hp--btn"
            @click="manageBooking"
            color="primary"
            >Continue</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto" max-width="1000" v-if="bookings.length > 0">
      <v-toolbar flat>
        <v-toolbar-title class="grey--text"
          >Manage your bookings</v-toolbar-title
        >
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-card flat v-for="booking in bookings" :key="booking.id">
          <v-layout class="pa-3">
            <v-flex xs12 sm12 md2 lg2 xl2>
              <div class="caption grey--text">Service</div>
              <div>{{ booking.service }}</div>
            </v-flex>
            <v-flex xs12 sm12 md2 lg2 xl2>
              <div class="caption grey--text">Name</div>
              <div>{{ booking.firstname }} {{ booking.lastname }}</div>
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 xl3>
              <div class="caption grey--text">Email</div>
              <div>{{ booking.email }}</div>
            </v-flex>
            <v-flex xs12 sm12 md2 lg2 xl2>
              <div class="caption grey--text">Appointment</div>
              <div>
                {{ booking.date | moment("Do MMM YYYY") }} {{ booking.slot }}
              </div>
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 xl3>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="success"
                      class="mr-2 white--text"
                      v-on="on"
                      v-bind="size"
                      @click="
                        resendEmail(
                          booking.id,
                          booking.iCalendar,
                          booking.time,
                          booking.date,
                          booking.company,
                          booking.event,
                          booking.room,
                          booking.firstname,
                          booking.lastname,
                          booking.email,
                          booking.mobile,
                          booking.bloodDropStart,
                          booking.bloodDropEnd,
                          booking.urinePotLocation,
                          booking.commsTemplate,
                          booking.eventSlotId
                        )
                      "
                    >
                      Resend
                      <v-icon right dark class="hidden-sm-and-down"
                        >mdi-email</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Send reminder email</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="error"
                      class="ma-2 white--text"
                      v-on="on"
                      v-bind="size"
                      @click="
                        cancelAppointment(
                          booking.id,
                          booking.eventSlotId,
                          booking.iCalendar,
                          booking.type,
                          booking.email,
                          booking.firstname,
                          booking.room,
                          booking.time,
                          booking.date,
                          booking.company,
                          booking.event,
                          booking.booked
                        )
                      "
                    >
                      Cancel
                      <v-icon right dark class="hidden-sm-and-down"
                        >mdi-calendar-remove</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Cancel appointment</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-card>
      </v-card-text>
    </v-card>
    <Footer />
  </v-container>
</template>

<script>
import { API } from "aws-amplify";
import { Booking } from "../classes/Booking";
import Footer from "../components/Footer.vue";
import Header from "../components/Header.vue";
export default {
  data() {
    return {
      bookingLoader: false,
      booking: [],
      bookings: [],
      nextToken: null,
      message: {
        showError: false,
        errorMessage: null,
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
        show: false,
        message: null
      },
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      }
    };
  },
  components: {
    Footer,
    Header
  },
  methods: {
    async manageBooking() {
      if (this.$refs.formManageBooking.validate()) {
        this.message.showError = false;
        this.bookingLoader = true;
        this.bookings = await this.nextRecord();
        while (this.nextToken !== null) {
          let nextEvents = await this.nextRecord();
          this.bookings.push(...nextEvents);
        }
        this.bookingLoader = false;
        if (this.bookings.length === 0) {
          this.showErrorMessage(
              "No bookings found for this name and email address"
          );
        }
      }
    },
    async nextRecord() {
      const bookingBySearchField = /* GraphQL */ `
        query BookingBySearchField(
          $searchField: String
          $sortDirection: ModelSortDirection
          $filter: ModelEventBookingFilterInput
          $limit: Int
          $nextToken: String
        ) {
          bookingBySearchField(
            searchField: $searchField
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
          ) {
            items {
              id
              firstname
              lastname
              email
              mobile
              dob
              isDeleted
              eventSlot {
                id
                time
                type
                length
                booked
                eventSlotGroup {
                  room
                  date
                  eventLocation {
                    event {
                      iCalendar
                      type
                    }
                  }
                }
              }
            }
            nextToken
          }
        }
      `;
      const searchQuery =
          this.booking.firstName.toLowerCase() +
          " " +
          this.booking.lastName.toLowerCase() +
          " " +
          this.booking.email.toLowerCase();

      const events = await API.graphql({
        query: bookingBySearchField,
        variables: {
          searchField: searchQuery,
          nextToken: this.nextToken
        },
        authMode: "API_KEY"
      });

      this.nextToken = events.data.bookingBySearchField.nextToken;

      const bookings = [];
      events.data.bookingBySearchField.items.forEach(function(event) {
        if(event.eventSlot) {
          if (event.eventSlot.type !== "register") {
            let service;
            switch (event.eventSlot.eventSlotGroup.eventLocation.event.type) {
              case "slot":
                service = "Health Assessment";
                break;
              case "workshop":
                service = "Workshop";
                break;
              case "healthscreening":
                service = "Health Assessment";
                break;
              case "virustesting":
                service = "Virus Testing";
                break;
            }
            bookings.push({
              id: event.id,
              firstname: event.firstname,
              lastname: event.lastname,
              email: event.email,
              slot: event.eventSlot.time,
              eventSlotId: event.eventSlot.id,
              room: event.eventSlot.eventSlotGroup.room,
              date: event.eventSlot.eventSlotGroup.date,
              iCalendar:
              event.eventSlot.eventSlotGroup.eventLocation.event.iCalendar,
              service: service
            });
          }
        }
      });
      return bookings;
    },
    async cancelAppointment(bookingId, eventSlotId, iCalendar) {
      const result = confirm(
          "Are you sure you want to cancel this appointment?"
      );

      if (result) {
        this.bookingLoader = true;
        const result = await Booking.cancelBooking({
          bookingId: bookingId,
          slotId: eventSlotId,
          iCalendar: iCalendar
        });
        if (result.success === "Email sent successfully") {
          this.showSuccessMessage("Booking cancelled");
          this.bookings = this.bookings.filter(
              booking => booking.id !== bookingId
          );
          this.bookingLoader = false;
        }
      }
    },
    async resendEmail(bookingId, eventSlotId, iCalendar) {
      const getEventBooking = /* GraphQL */ `
        query GetEventBooking($id: ID!) {
          getEventBooking(id: $id) {
            id
            firstname
            lastname
            email
            mobile
            dob
            customData
            createdAt
            startTime
            twentyFourHourReminder
            fortyEightHourReminder
            searchField
            isDeleted
            updatedAt
            eventSlot {
              id
              time
              eventSlotGroup {
                id
                room
                date
                eventLocation {
                  id
                  event {
                    id
                    bloodDropStart
                    bloodDropEnd
                    urinePotLocation
                    name
                    commsTemplate
                    eventCompany {
                      id
                      name
                    }
                  }
                }
              }
              eventBooking {
                nextToken
              }
            }
          }
        }
      `;
      this.bookingLoader = true;
      const {
        data: { getEventBooking: booking }
      } = await API.graphql({
        query: getEventBooking,
        variables: {
          id: bookingId
        },
        authMode: "API_KEY"
      });
      const bookingEmail = await Booking.sendBookingEmail({
        slotTime: booking.eventSlot.time,
        eventDate: booking.eventSlot.eventSlotGroup.date,
        company:
        booking.eventSlot.eventSlotGroup.eventLocation.event.eventCompany
            .name,
        event: booking.eventSlot.eventSlotGroup.eventLocation.event.name,
        room: booking.eventSlot.eventSlotGroup.room,
        firstname: booking.firstname,
        lastname: booking.lastname,
        email: booking.email,
        phone: booking.mobile,
        iCalendar: iCalendar,
        bloodDropStart:
        booking.eventSlot.eventSlotGroup.eventLocation.event.bloodDropStart,
        bloodDropEnd:
        booking.eventSlot.eventSlotGroup.eventLocation.event.bloodDropEnd,
        urinePotLocation:
        booking.eventSlot.eventSlotGroup.eventLocation.event.urinePotLocation,
        commsTemplateId:
        booking.eventSlot.eventSlotGroup.eventLocation.event.commsTemplate,
        browser: this.$browserDetect.meta
      });
      this.bookingLoader = false;
      if (bookingEmail.success === "Email sent successfully") {
        this.showSuccessMessage("Reminder email sent");
      }
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    },
    showErrorMessage(message) {
      this.message = {
        showError: false,
        errorMessage: null
      };
      this.message.errorMessage = message;
      this.message.showError = true;
    }
  },
  computed: {
    size() {
      const size = { xs: "x-small", sm: "x-small", md: "x-small", lg: "small" }[
          this.$vuetify.breakpoint.name
          ];
      return size ? { [size]: true } : {};
    }
  }
};
</script>
